import { RowTurnDto } from "@/dtos";
import { Turn } from "@/entities";
import { getTurnTypeOption } from "@/helpers/options/routes/turns/turn-type";

export const formatRowTurnDto = (turns: Turn[]): RowTurnDto[] => {
    return turns.map((x) => {
        const row: RowTurnDto = {
            ...x,
            type_label: getTurnTypeOption(parseInt(x.type)).label,
            route_group_label: x.route_group.name,
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}